<template>
  <div>
    <el-form :model="updateForm" :loading="loading">
      <el-form-item label="旧密码" required>
        <el-input placeholder="请输入旧密码" :show-password="true" v-model="updateForm.oldPassword"/>
      </el-form-item>
      <el-form-item label="新密码" required>
        <el-input placeholder="请输入新密码" :show-password="true" v-model="updateForm.newPassword"/>
      </el-form-item>
      <el-form-item label="新确认新密码" required>
        <el-input placeholder="请再次新密码" :show-password="true" v-model="updateForm.retryPassword"/>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="submit">确 定</el-button>
        <el-button @click="cancel">取 消</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import {updatePsw} from './loginApi'

export default {
  name: 'updatePswByOldPsw',
  data () {
    return {
      loading: false,
      updateForm: {
        oldPassword: '',
        newPassword: '',
        retryPassword: ''
      }
    }
  },
  methods: {
    submit () {
      if (this.updateForm.oldPassword.trim().length === 0) {
        this.$message.error('旧密码不能为空')
        return false
      }
      if (this.updateForm.newPassword.trim().length === 0) {
        this.$message.error('新密码不能为空')
        return false
      }
      if (this.updateForm.newPassword !== this.updateForm.retryPassword) {
        this.$message.error('两次输入的密码不一致')
        return false
      }
      this.loading = true
      updatePsw(this.updateForm).then(rsp => {
        this.loading = false
        const {code, message} = rsp
        if (code === 0) {
          this.$message.success('修改成功')
          this.$emit('success')
        } else {
          this.$message.error(message)
        }
      }).catch(() => {
        this.loading = false
      })
    },
    cancel () {
      this.$emit('cancel')
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Login/updatePswByOldPsw.vue